import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import template from './pager.vue';
import { uniq, sortBy } from 'lodash-es';
import UinsDefaultSelect from '../unisDefaultSelect';

@Component({
    mixins: [template],
    name: 'pager',
    components: {
        UinsDefaultSelect,
    },
})
export default class Pager extends Vue {
    @Prop({ default: 10 })
    customizePageSize: number;

    @Prop({ default: 0 })
    totalCount: number;

    @Prop({ default: 3 })
    pagerShowCount: number;

    @Prop({ default: 1 })
    currentPage: number;

    @Prop({ default: () => [] })
    pageOptions: Array<any>;

    get showingFrom() {
        return (this.pager.activedPage - 1) * this.pageSize + 1;
    }

    get showingTo() {
        return this.pager.activedPage * this.pageSize > this.totalCount
            ? this.totalCount
            : this.pager.activedPage * this.pageSize;
    }

    pager = {
        activedPage: 1,
        totalPage: 0,
        pagerShowCount: 0,
        halfPagerShowCount: 0,
        low: 0,
        high: 0,
    };
    pageSize = 0;
    inputPage = 1;
    lastPageSize = 0;
    lastTotalCount = 0;
    isShow = false;
    isNext = false;
    totalPage = 0;
    halfPagerShowCount = this.pagerShowCount / 2;
    stay = false;
    pages: any[] = [];
    pageSizeOptions: any[] = [10, 20, 50];

    mounted() {
        this.pageSize = this.customizePageSize;
        this.setupPageSizeOptions();
        this.initialPager();
        this.loadDefaultPager();
        if (this.totalCount > this.currentPage) this.isShow = true;
        else this.isShow = false;
    }

    @Watch('totalCount')
    updateWhenTotalCountChange(val: any) {
        if (val == 0) {
            this.pages = [];
            return;
        }

        if (this.totalCount === 0 || this.lastTotalCount == this.totalCount) return;
        this.reInitialPager();
        if (this.totalCount > this.currentPage) this.isShow = true;
        else this.isShow = false;
    }

    @Watch('customizePageSize')
    reRenderWhenCustomizePageSizeChange(data: any) {
        // if(data )
        this.pages = this.loadPager(this.pager.activedPage);
        this.reRenderWhenPageSizeChange(this.customizePageSize);
    }

    @Watch('currentPage')
    updateWhenCurrentPageChange() {
        this.isNext = false;
        if (this.currentPage != this.pager.activedPage) {
            if (this.pager.activedPage == this.currentPage) return;
            this.pager.activedPage = this.currentPage;
            this.inputPage = this.currentPage;
            this.pages = this.loadPager(this.pager.activedPage);
        }
        if (this.totalCount > this.currentPage) this.isShow = true;
        else this.isShow = false;
    }

    reRenderWhenPageSizeChange(selectPageSize: number) {
        console.log('Page Size change from inside' + selectPageSize);
        if (selectPageSize) {
            this.pageSize = selectPageSize;
        }
        if (this.pageSize === 0 || this.lastPageSize == this.pageSize) return;
        this.reInitialPager();
        this.inputPage = this.pager.activedPage;
        this.isNext = true;
        this.countIsNext();
        this.$emit('reloadContent', {
            currentPage: this.pager.activedPage,
            pageSize: this.pageSize,
        });
    }

    private countIsNext() {
        if (this.isNext)
            setTimeout(() => {
                this.isNext = false;
            }, 3000);
    }

    private loadPage(page: number) {
        this.changeActivePage(page);
    }

    loadFirstPage() {
        this.changeActivePage(1);
    }

    loadPrevPage() {
        this.changeActivePage(this.pager.activedPage - 1 > 0 ? this.pager.activedPage - 1 : 1);
    }

    loadNextPage() {
        this.changeActivePage(
            this.pager.activedPage + 1 > this.pager.totalPage
                ? this.pager.totalPage
                : this.pager.activedPage + 1
        );
    }

    loadLastPage() {
        this.changeActivePage(this.pager.totalPage);
    }

    goToPage() {
        let number = this.inputPage > this.pager.totalPage ? this.pager.totalPage : this.inputPage;
        this.changeActivePage(Number(number));
    }

    pageSizePage(pageSize: any) {
        this.pageSize = pageSize;
        this.changeActivePage(1, true);
    }

    private changeActivePage(page: number, ispageSize: boolean = false) {
        if (this.pager.activedPage == page && !ispageSize) return;
        this.pager.activedPage = page;
        this.inputPage = page;
        this.pages = this.loadPager(this.pager.activedPage);
        this.isNext = true;
        this.countIsNext();
        this.$emit('reloadContent', {
            currentPage: page,
            pageSize: this.pageSize,
            totalCount: this.totalCount,
        });
    }

    private initialPager() {
        this.pager.pagerShowCount = this.pagerShowCount;
        this.pager.halfPagerShowCount = Math.floor(this.pager.pagerShowCount / 2);
        this.pager.totalPage = Math.ceil(this.totalCount / this.pageSize);
        this.lastTotalCount = this.totalCount;
        this.lastPageSize = this.pageSize;
    }

    loadDefaultPager() {
        this.pager.activedPage = 1;
        this.pages = this.loadPager(this.pager.activedPage);
    }

    reInitialPager() {
        this.initialPager();
        if (this.stay) {
            if (this.pager.activedPage > this.pager.totalPage) {
                this.pager.activedPage = 1;
            }
            let reActivePage = this.pager.activedPage;
            this.pager.activedPage = -1;
            this.changeActivePage(reActivePage);
        } else {
            this.pager.activedPage = 1;
            this.pages = this.loadPager(this.pager.activedPage);
            //  comment out this since it will cause the content load twice.
            //  this.$emit("reloadContent", ({'currentPage': this.pager.activedPage, 'pageSize': this.pageSize, 'totalCount': this.totalCount}));
        }
    }

    setupPageSizeOptions() {
        if (this.pageOptions && this.pageOptions.length > 0) {
            this.pageSizeOptions = this.pageOptions;
        } else {
            let defaultPageSizeOptions = [10, 20, 50];
            defaultPageSizeOptions.push(this.pageSize);
            this.pageSizeOptions = sortBy(uniq(defaultPageSizeOptions));
        }
    }

    loadPager(activedPage: number) {
        let halfPagerShowCount = this.pager.halfPagerShowCount;
        let totalPage = this.pager.totalPage;
        let pagerShowCount = this.pager.pagerShowCount;

        let pages = [];
        let low =
            activedPage - halfPagerShowCount <= 1
                ? 1
                : activedPage + halfPagerShowCount <= totalPage
                ? activedPage - halfPagerShowCount
                : totalPage - (pagerShowCount - 1) <= 1
                ? 1
                : totalPage - (pagerShowCount - 1);
        let high = low + (pagerShowCount - 1) <= totalPage ? low + (pagerShowCount - 1) : totalPage;
        for (let i = low; i <= high; i++) {
            if (i === activedPage) {
                pages.push({ number: i, active: true });
            } else {
                pages.push({ number: i, active: false });
            }
        }
        this.pager.low = low;
        this.pager.high = high;
        return pages;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/pager/index.ts